/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Booking_LeadInputs */

const en_features_booking_lead = /** @type {(inputs: Features_Booking_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book your coach in two taps.`)
};

const pl_features_booking_lead = /** @type {(inputs: Features_Booking_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termin u trenera w dwa dotknięcia.`)
};

/**
* | output |
* | --- |
* | "Book your coach in two taps." |
*
* @param {Features_Booking_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_booking_lead = /** @type {((inputs?: Features_Booking_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Booking_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_booking_lead(inputs)
	return en_features_booking_lead(inputs)
});